module.exports = __webpack_public_path__ + "static/media/wind.323e9f29.svg";